import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import TaskSkeleton from "./TaskSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

export default function Dashboard() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [TaskCount, setTaskCount] = useState();
  const [date, setDate] = useState(null);
  const [remark, setRemark] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [loginUserId, setloginUserId] = useState(user.id);
  const [selectedDepartmentId, setselectedDepartmentId] = useState("");
  const [selectedUser, setselectedUser] = useState("");
  const [selectedStatus, setsselectedStatus] = useState("Pending");
  const [startDate, setstartDate] = useState("");
  const [endDate, setendDate] = useState("");
  const [dueamt, setDue] = useState("");
  const [userss, setUserss] = useState([]);
  const [colleges, setColleges] = useState([]);
  const [switchingTo, setSwitchingTo] = useState(null);

  useEffect(() => {
    if (user.department_id === 1) {
      http.get('/multi_login_board_switch_list').then((res) => {
        if (res.data && Array.isArray(res.data.data)) {
          setColleges(res.data.data);
        }
      }).catch(() => {});
    }
  }, []);

  const handleGoToCollege = async (companyId, companyName) => {
    if (!window.confirm(`Go to ${companyName}?`)) return;
    setSwitchingTo(companyId);
    try {
      const res = await http.post('/multi_login_board_switch', { company_id: companyId });
      if (res.data && res.data.access_token && res.data.user) {
        localStorage.clear();
        localStorage.setItem("token", JSON.stringify(res.data.access_token));
        localStorage.setItem("user", JSON.stringify(res.data.user));
        window.location.href = '/#/dashboard';
        window.location.reload();
        return;
      } else {
        toast.error("Failed to switch - invalid response");
        setSwitchingTo(null);
      }
    } catch (error) {
      toast.error("Failed to switch college");
      setSwitchingTo(null);
    }
  };


  const fetchTaskDetails = (
    seldepartment = "",
    selstatus = "",
    startDate = "",
    endDate = "",
    seluser = ""
  ) => {
    setIsLoading(true);
    let endpoint;
    if (user && user.department_id === 1) {
      endpoint = `/tasks?department=${seldepartment}&status=${selstatus}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}&seluser=${seluser}`;
    } else if (user) {
      endpoint = `/tasks?user=${user.id}&department=${seldepartment}&status=${selstatus}&login_user=${user.id}&startdate=${startDate}&enddate=${endDate}&seluser=${seluser}`;
    } else {
      setIsLoading(false);
      console.error("User is not defined or authenticated");
      return;
    }

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
          setTaskCount(res.data.data.length);
        } else {
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });

    http.get(`/departments?login_user=${user.id}`).then((res) => {
      setdepartments(res.data.data);
    });
  };

  const [showModal, setShowModal] = useState(false);
  const [showModalRevise, setShowModalRevise] = useState(false);
  const [ModalId, setModalId] = useState(false);
  const openModal = (taskId) => {
    setShowModal(true);
    setModalId(taskId);
  };

  const openModalRevise = (rmark, revisedate) => {
    setDate(revisedate);
    setRemark(rmark);
    setShowModalRevise(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModalRevise(false);
  };
  const handleChange = async (event) => {
    setselectedDepartmentId(event.target.value);
  };

  const handleChangeUser = async (event) => {
    setselectedUser(event.target.value);
  };

  const handleChangeType = async (event) => {
    setsselectedStatus(event.target.value);
  };

  const handleChangeStartDate = async (event) => {
    setstartDate(event.target.value);
  };

  const handleChangeEndDate = async (event) => {
    setendDate(event.target.value);
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/tasks/${taskId}`)
      .then((response) => {
        toast.success("Task Deleted successfully !");
        // setTasks(response.data.data);
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const handleSave = async (taskId) => {
    if (currentStatus === null || taskId === null) {
      toast.error("Please select proper status");
      return true;
    }
    try {
      const response = await http.put(
        `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails(selectedDepartmentId, selectedStatus);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Please select proper item");
    }
  };

  const [formData, setFormData] = useState({
    revised_date: "",
    revised_remark: "",
  });
  const initialState = {
    revised_date: "",
    revised_remark: "",
  };

  const handleChangeModal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.revised_remark || !formData.revised_date) {
      toast.error("Please fill in both Revised Remark and New Revision Date.");
      return;
    }
    try {
      http.put(`/revise/${ModalId}`, formData).then((res) => {
        toast.success("revise date added successfully !");
        setFormData(initialState);
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
        closeModal();
      });
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  const downloadFile = (filename) => {
    // Construct the URL to the file.
    const fileUrl = `http://3.6.125.26/api/storage/tasks/${filename}`;

    // Create a link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", ""); // the download attribute can be empty
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Remove the link from the DOM
  };
  function getRandomLightColor() {
    const letters = "0123456789ABCDEF";
    let color = "#";
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  const backgroundColorMap = new Map();

  // Function to get a unique background color for a user.id
  function getUniqueBackgroundColor(userId) {
    if (!backgroundColorMap.has(userId)) {
      // If the user.id doesn't have a background color assigned, generate one and store it in the map
      backgroundColorMap.set(userId, getRandomLightColor());
    }
    return backgroundColorMap.get(userId);
  }


  return (
    <>
      <div className="container-fluid pt-4 px-4">
        <div className="row g-4">
          <div className="col-sm-6 col-xl-3">
            <Link to="/duereport" style={{ textDecoration: 'none' }}>
              <div className="dashboard-card hover-shadow" style={{ cursor: 'pointer', transition: 'box-shadow 0.2s' }}>
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <p className="mb-2 text-gradient fw-bold">Total Dues</p>
                    <div className="mb-0" style={{ fontSize: '2.5rem', fontWeight: 800 }}>
                      <i className="fa fa-wallet text-gradient"></i>
                    </div>
                  </div>
                  <i className="fa fa-chart-line fa-2x text-gradient opacity-75"></i>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-sm-6 col-xl-3">
            <div className="dashboard-card">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="mb-2 text-gradient fw-bold">Total Teachers</p>
                  <h3 className="text-gradient mb-0">0</h3>
                </div>
                <i className="fa fa-chart-bar fa-2x text-gradient opacity-75"></i>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-xl-3">
            <div className="dashboard-card">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="mb-2 text-gradient fw-bold">Admins</p>
                  <h3 className="text-gradient mb-0">0</h3>
                </div>
                <i className="fa fa-chart-area fa-2x text-gradient opacity-75"></i>
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-xl-3">
            <div className="dashboard-card">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <p className="mb-2 text-gradient fw-bold">Others</p>
                  <h3 className="text-gradient mb-0">0</h3>
                </div>
                <i className="fa fa-chart-pie fa-2x text-gradient opacity-75"></i>
              </div>
            </div>
          </div>
        </div>
        {user.department_id === 1 && colleges.length > 0 && (
          <div className="row g-4 mt-2">
            <div className="col-12">
              <div style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '16px', padding: '20px 24px', color: '#fff',
                display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '4px'
              }}>
                <i className="fa fa-university" style={{ fontSize: '1.5rem' }}></i>
                <div>
                  <h5 className="mb-0 fw-bold">Your Colleges</h5>
                  <small style={{ opacity: 0.85 }}>Quick access to all your institutions</small>
                </div>
              </div>
            </div>
            {colleges.map((item, idx) => {
              const colors = [
                ['#667eea', '#764ba2'],
                ['#f093fb', '#f5576c'],
                ['#4facfe', '#00f2fe'],
                ['#43e97b', '#38f9d7'],
                ['#fa709a', '#fee140'],
                ['#a18cd1', '#fbc2eb'],
                ['#fccb90', '#d57eeb'],
                ['#0250c5', '#d43f8d'],
              ];
              const [c1, c2] = colors[idx % colors.length];
              return (
                <div key={item.id} className="col-sm-6 col-md-4 col-lg-3">
                  <div style={{
                    background: '#fff', borderRadius: '14px', overflow: 'hidden',
                    boxShadow: '0 2px 16px rgba(0,0,0,0.08)', transition: 'transform 0.2s, box-shadow 0.2s',
                    cursor: 'pointer', border: '1px solid #eee'
                  }}
                    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 30px rgba(0,0,0,0.15)'; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 16px rgba(0,0,0,0.08)'; }}
                  >
                    <div style={{
                      background: `linear-gradient(135deg, ${c1}, ${c2})`,
                      padding: '20px', textAlign: 'center'
                    }}>
                      <i className="fa fa-university" style={{ fontSize: '2rem', color: '#fff' }}></i>
                    </div>
                    <div style={{ padding: '16px' }}>
                      <h6 style={{ fontWeight: 700, marginBottom: '4px', color: '#333', fontSize: '0.95rem' }}>
                        {item.company_name}
                      </h6>
                      <small style={{ color: '#888' }}>{item.company_code} &middot; {item.board_name}</small>
                      <div style={{ marginTop: '12px' }}>
                        <button
                          className="btn btn-sm w-100"
                          disabled={switchingTo === item.company_id}
                          onClick={() => handleGoToCollege(item.company_id, item.company_name)}
                          style={{
                            background: `linear-gradient(135deg, ${c1}, ${c2})`,
                            color: '#fff', border: 'none', borderRadius: '8px',
                            fontWeight: 600, padding: '8px 0', fontSize: '0.9rem',
                            letterSpacing: '0.5px'
                          }}
                        >
                          {switchingTo === item.company_id ? (
                            <><span className="spinner-border spinner-border-sm me-1"></span>Going...</>
                          ) : (
                            <><i className="fa fa-arrow-right me-2"></i>Go</>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* Dummy Graph Cards Row */}
        <div className="row g-4 mt-2">
          <div className="col-md-4">
            <div className="dashboard-card position-relative" style={{ minHeight: '180px' }}>
              <span className="badge bg-warning position-absolute top-0 end-0 m-3" style={{fontSize: '0.9rem'}}>Coming Soon</span>
              <h5 className="mb-3">Sales Overview</h5>
              <div style={{height: '100px', background: 'linear-gradient(90deg, #e0eafc 0%, #cfdef3 100%)', borderRadius: '8px', opacity: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#185a9d'}}>
                <svg width="100%" height="100%" viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg">
                  <rect width="100" height="50" fill="#e0eafc" />
                  <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize="12" fill="white">Bar Chart</text>
                </svg>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="dashboard-card position-relative" style={{ minHeight: '180px' }}>
              <span className="badge bg-warning position-absolute top-0 end-0 m-3" style={{fontSize: '0.9rem'}}>Coming Soon</span>
              <h5 className="mb-3">Agent Report</h5>
              <div style={{height: '100px', background: 'linear-gradient(90deg, #e0eafc 0%, #cfdef3 100%)', borderRadius: '8px', opacity: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#185a9d'}}>
                <svg width="100%" height="100%" viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg">
                  <rect width="100" height="50" fill="#e0eafc" />
                  <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize="12" fill="white">Line Chart</text>
                </svg>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="dashboard-card position-relative" style={{ minHeight: '180px' }}>
              <span className="badge bg-warning position-absolute top-0 end-0 m-3" style={{fontSize: '0.9rem'}}>Coming Soon</span>
              <h5 className="mb-3">Performance Chart</h5>
              <div style={{height: '100px', background: 'linear-gradient(90deg, #e0eafc 0%, #cfdef3 100%)', borderRadius: '8px', opacity: 0.5, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#185a9d'}}>
                <svg width="100%" height="100%" viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg">
                  <rect width="100" height="50" fill="#e0eafc" />
                  <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize="12" fill="white">Pie Chart</text>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
